class AbcBar extends HTMLElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.evenst();
    }

    load() {
        const span = this.querySelector("input[checked]").nextElementSibling;
        span.scrollIntoView({
            behavior: "auto", // o "smooth"
            inline: "center",
            block: "nearest",
        });
    }

    evenst() {
        this.addEventListener("click", (e) => {
            const target = e.target;
            if ((filter = target.closest("[name=abc]"))) {
                window.location.href = filter.value;
            }
        });
    }
}

customElements.define("abc-bar", AbcBar);
